module.exports = __webpack_public_path__ + "img/success.f523ccaa.png";